import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

/* -------------- */
/*    CURRENCY    */
/* -------------- */
export const FIND_PARTY_CASES = 'FIND_PARTY_CASES';
export const FIND_PARTY_CASE_BY_ID = 'FIND_PARTY_CASE_BY_ID';
export const FIND_PARTY_CASES_BY_PARTY_ID = 'FIND_PARTY_CASES_BY_PARTY_ID';
export const FIND_PARTY_CASES_GROUPS_BY_PARTY_ID = 'FIND_PARTY_CASES_GROUPS_BY_PARTY_ID';

export const FIND_PARTY_CASE_POSTPONE_BY_ID = 'FIND_PARTY_CASE_POSTPONE_BY_ID';
export const FIND_PARTY_CASE_POSTPONE_BY_PARTY_ID = 'FIND_PARTY_CASE_POSTPONE_BY_PARTY_ID';

export const FIND_ALL_SCREENING_LIST_TYPES = 'FIND_ALL_SCREENING_LIST_TYPES';
export const SEARCH_SCREENING_LISTS = 'SEARCH_SCREENING_LISTS';

export const FIND_PARTY_CASE_SCREENING_LISTS = 'FIND_PARTY_CASE_SCREENING_LISTS';

export const FIND_PARTY_CASE_BY_SERVICE_CODE_FOR_USER = 'FIND_PARTY_CASE_BY_SERVICE_CODE_FOR_USER';

export const GET_DIRECT_PARTY_CASE_BY_SERVICE_CODE = 'GET_DIRECT_PARTY_CASE_BY_SERVICE_CODE';

export const partyCaseApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const usePartyCaseApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...partyCaseApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling partyu api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
